import { render } from "./order.vue?vue&type=template&id=3afd45a0&scoped=true"
import script from "./order.vue?vue&type=script&lang=js"
export * from "./order.vue?vue&type=script&lang=js"

import "./order.vue?vue&type=style&index=0&id=3afd45a0&lang=css"
import "./order.vue?vue&type=style&index=1&id=3afd45a0&scoped=true&lang=css"

import exportComponent from "D:\\Code\\mt\\hql\\bm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3afd45a0"]])

export default __exports__